// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { createProductFamily } from "./schema/product-catalog/create-product-family";
import { createProductFamilyFromImages } from "./schema/product-catalog/create-product-family-from-images";
import { getProductDetails } from "./schema/product-catalog/get-product-details";
import { getProductFamilyDetails } from "./schema/product-catalog/get-product-family-details";
import { listProductBinsAtLocation } from "./schema/product-catalog/list-product-bins-at-location";
import { searchBins } from "./schema/product-catalog/search-bins";
import { setProductBins } from "./schema/product-catalog/set-product-bins";
import { updateProduct } from "./schema/product-catalog/update-product";
import { updateProductFamily } from "./schema/product-catalog/update-product-family";
import { addProductVariant } from "./schema/product-families/add-product-variant";
import { getImageOptimizationStatus } from "./schema/product-families/get-image-optimization-status";
import { startImageOptimization } from "./schema/product-families/start-image-optimization";
import { submitImageFeedback } from "./schema/product-families/submit-image-feedback";
import { updateImageDefaults } from "./schema/product-families/update-image-defaults";
import { uploadProductFamilyImages } from "./schema/product-families/upload-product-family-images";

export const groupC = {
  createProductFamily,
  createProductFamilyFromImages,
  getProductDetails,
  getProductFamilyDetails,
  listProductBinsAtLocation,
  searchBins,
  setProductBins,
  updateProduct,
  updateProductFamily,
  addProductVariant,
  getImageOptimizationStatus,
  startImageOptimization,
  submitImageFeedback,
  updateImageDefaults,
  uploadProductFamilyImages,
};
